import React, { StrictMode } from 'react';

import { ContextProvider as UsersContextProvider } from 'components/Users/Context';
import Show from './Views/Show/Index';

export default function Index() {
  return (
    <StrictMode>
      <UsersContextProvider>
        <Show />
      </UsersContextProvider>
    </StrictMode>
  );
}
